import { render } from "./icons.vue?vue&type=template&id=674a31ee&scoped=true"
import script from "./icons.vue?vue&type=script&lang=js"
export * from "./icons.vue?vue&type=script&lang=js"

import "./icons.vue?vue&type=style&index=0&id=674a31ee&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674a31ee"]])

export default __exports__